import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { DragDropModule } from '@angular/cdk/drag-drop';

interface ValidationModalData {
  title: string;
  content: string;
  content2?: string;
  icon?: 'success' | 'error' | 'warning';
  showCancelButton?: boolean;
}

@Component({
    selector: 'app-validation-modal',
    imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, MatDividerModule, DragDropModule],
    templateUrl: './validation-modal.component.html',
    styleUrls: ['./validation-modal.component.scss']
})
export class ValidationModalComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: ValidationModalData) {}

  getHeaderClass(): string {
    return 'success-header';
  }

  getIconClass(): string {
    switch (this.data.icon) {
      case 'error':
        return 'error-icon';
      case 'warning':
        return 'warning-icon';
      default:
        return 'success-icon';
    }
  }

  getIcon(): string {
    switch (this.data.icon) {
      case 'error':
        return 'error_outline';
      case 'warning':
        return 'warning';
      default:
        return 'check_circle';
    }
  }

  getButtonColor(): string {
    return 'primary';
  }
}
